import React from "react";
import "./submit.scss";
import tickIcon from "../../images/tickIcon.png";
import SecondaryButton from "../../components/button/SecondaryButton";

const Submit = () => {
  return (
    <div className="formSubmit">
      <div className="img">
        <img src={tickIcon} width="71px" height="66px" alt="ticj icon" />
      </div>

      <div className="submitContent">
        <h3>Order Form Successfully Submitted!</h3>
        <p>
          Thank you for submitting your order.
        </p>
        <div className="submitButton">
          <SecondaryButton text="Go to Home" to="/" />
        </div>
      </div>
    </div>
  );
};

export default Submit;
